import React, { useEffect, useRef, useState } from "react";
import { Hero } from "../components/Hero";
import { StickyOfferBar } from "../components/StickyOfferBar";
import { StatsStrip } from "../components/StatsStrip";
import { ProblemSection } from "../components/ProblemSection";
import { SolutionSection } from "../components/SolutionSection";
import { WorkshopsSection } from "../components/WorkshopsSection";
import { SampleCarousel } from "../components/SampleCarousel";
import { BonusesSection } from "../components/BonusesSection";
import { OfferSection } from "../components/OfferSection";
import { FaqSection } from "../components/FaqSection";
import { ClosingSection } from "../components/ClosingSection";
import { SiteFooter } from "../components/SiteFooter";
export function Landing() {
  const heroRef = useRef<HTMLDivElement>(null);
  const offerRef = useRef<HTMLDivElement>(null);
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  useEffect(() => {
    const heroObserver = new IntersectionObserver(([entry]) => setPastHero(!entry.isIntersecting));
    const offerObserver = new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting), {
      threshold: 0.15
    });
    if (heroRef.current) heroObserver.observe(heroRef.current);
    if (offerRef.current) offerObserver.observe(offerRef.current);
    return () => {
      heroObserver.disconnect();
      offerObserver.disconnect();
    };
  }, []);
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-226" data-mp="gz6kdy25cigq">
      <StickyOfferBar visible={pastHero && !offerVisible} data-id="element-227" data-mp="c7y5wnlym6wp" />
      <a className="skip-link" href="#main-content" data-id="element-228" data-mp="c63m5cmfcku7">Skip to content</a>
      <main id="main-content" data-id="element-229" data-mp="78bumjpoz0qj">
        <div ref={heroRef} data-id="element-230" data-mp="770qujw8xszf">
          <Hero data-id="element-231" data-mp="14o8zay5ebx7j" />
        </div>
        <StatsStrip data-id="element-232" data-mp="14pkahj16878o" />
        <ProblemSection data-id="element-233" data-mp="14ptsajc2b83a" />
        <SampleCarousel data-id="element-234" data-mp="14qc08d837ar1" />
        <SolutionSection data-id="element-235" data-mp="zx8znl4w711c" />
        <WorkshopsSection data-id="element-236" data-mp="zx0obxof43s9" />
        <BonusesSection data-id="element-237" data-mp="zvpkjxuz2w15" />
        <div ref={offerRef} data-id="element-238" data-mp="1iu18a70ykhoa">
          <OfferSection data-id="element-239" data-mp="1itrgcdwcs0fy" />
        </div>
        <FaqSection data-id="element-240" data-mp="1iusyf2bsdn76" />
        <ClosingSection data-id="element-241" data-mp="1nt4azktgubt3" />
      </main>
      <SiteFooter data-id="element-242" data-mp="1ns2n2frcputy" />
    </div>;
}